import { Box, Button, Stack } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { getMobileQuickNavItems, PAGE_GUTTER } from './navConfig';
import { alpha, tokens } from '../../theme/tokens';

/**
 * Compact browse-only strip under the mobile header.
 */
export function MobileQuickNav() {
  const location = useLocation();
  const items = getMobileQuickNavItems();

  return (
    <Box
      sx={{
        display: { xs: 'block', md: 'none' },
        position: 'relative',
        flexShrink: 0,
        // Solid fill so feed content never shows through while scrolling
        bgcolor: 'transparent',
        borderTop: `1px solid ${alpha('#FFFFFF', 0.16)}`,
        overflow: 'hidden',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'hidden',
          px: PAGE_GUTTER,
          py: { xs: 1, sm: 1.25 },
          boxSizing: 'border-box',
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ width: '100%', minWidth: 0 }}
        >
          {items.map((item) => {
            const Icon = item.icon;
            const active = item.to === '/'
              ? location.pathname === '/'
              : item.end
                ? location.pathname === item.to
                : location.pathname === item.to ||
                  location.pathname.startsWith(`${item.to}/`);

            return (
              <Button
                key={item.to}
                component={NavLink}
                to={item.to}
                replace
                end={Boolean(item.end)}
                size="small"
                variant={active ? 'contained' : 'outlined'}
                color={active ? 'secondary' : 'inherit'}
                startIcon={<Icon sx={{ fontSize: 18 }} />}
                sx={{
                  flex: '1 1 0',
                  minWidth: '0 !important',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  px: 1.25,
                  py: 0.85,
                  minHeight: 44,
                  borderRadius: '999px',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                  borderColor: active ? 'transparent' : alpha('#FFFFFF', 0.35),
                  bgcolor: active ? undefined : alpha('#FFFFFF', 0.1),
                  color: active ? undefined : tokens.onShell,
                  boxShadow: active
                    ? `0 4px 12px ${alpha(tokens.brand, 0.32)}`
                    : 'none',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {item.label}
              </Button>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
}
